// extracted by css-extract-rspack-plugin
export default {"container":"Description-module__container__gggAP","header":"Description-module__header__XVBOA"};